module.exports = __webpack_public_path__ + "img/57c00f797102490db7cb8e650d711b2e-1024.563533e1.jpg";